// extracted by mini-css-extract-plugin
export default {"saveButton":"saveButton_saveButton__4w3IR","large":"saveButton_large__tT8BE","icon":"saveButton_icon__bxEcW"};